import * as React from "react";
import { useRef, useState } from "react";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { deleteNode } from "../Helpers/Nodes";
import EditorActions from "../Shared/Edit/EditorActions";
import RemoveDialog from "../Shared/Remove/RemoveDialog";
import Scrollable from "../Shared/Edit/Scrollable";
import { uuidv4 } from "../Attributes/Fields/TreeDropdownHelper";
import { updatePlanningConfiguration } from "../../API/Planning/Planning";

class DragCell extends React.Component {
	render() {
		return (
			<td
				style={{ textAlign: "center" }}
				onDragOver={(e) => {
					DragCell.reorder(this.props.dataItem);
					e.preventDefault();
					e.dataTransfer.dropEffect = "copy";
				}}
				onDragEnd={(e) => {
					e.preventDefault();
					DragCell.endDrag(this.props.dataItem);
				}}
			>
				<span
					draggable="true"
					style={{ cursor: "move" }}
					onDragStart={(e) => {
						DragCell.dragStart(this.props.dataItem);
						e.dataTransfer.setData("dragging", "");
					}}
				>
					<i className="mx-1 draggable-icon fas fa-ellipsis-v"></i>
					{this.props.dataItem.indexId}
				</span>
			</td>
		);
	}
}

function InputCell(props) {
	const [initValue, na] = useState(props.dataItem.key);
	const ref = useRef(null);
	return (
		<td>
			<input
				ref={ref}
				onBlur={() => {
					if (ref.current.value !== initValue) props.dataItem.onSave();
				}}
				data-id={props.dataItem._id}
				disabled={props.dataItem.key === "Feedback" ? true : false}
				key={props.dataItem._id}
				onChange={props.dataItem.onChange}
				className={`form-control ${props.dataItem.error && "is-invalid"} `}
				value={props.dataItem.key}
			/>

			{props.dataItem.error && (
				<span className="my-2 d-inline-block">
					<i className="text-warning fas fa-exclamation-triangle mx-1"></i>
					This field can not be empty. You can use <i className="fas fa-times mx-1"></i> button to remove it.
				</span>
			)}
		</td>
	);
}

class OrganisationPlanningSidebar extends React.Component {
	oldData = [];
	saveButton = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			propsdata: props.SideData,
			fieldName: props.SideData.fieldName,
			data: [],
			toDeleteItem: [],
			delete: {
				key: false,
				message: "",
			},
			completeState: [],
			DeletePopup: false,
			olddata: [],
		};
		DragCell.reorder = this.reorder.bind(this);
		DragCell.dragStart = this.dragStart.bind(this);
		DragCell.endDrag = this.endDrag.bind(this);
	}

	componentDidMount = () => {

		this.userRole = this.props.userRole;
		let sortedData = this.props.SideData.data.slice().sort((a, b) => a.order - b.order);
		this.oldData = this.props.SideData.data.slice();
		let data = sortedData.map((i) => ({ ...i }));
		this.oldcompleteState = sortedData.find((item) => item.completeState);
		let options = [];

		if (this.props.SideData.fieldName === "State") {
			options = [...data];
		}
		this.setState({
			data: data,
			completeState: sortedData.find((item) => item.completeState),
			olddata: data.slice(),
			options,
		});
		this.rowClick(sortedData[0]._id);
	};

	componentWillReceiveProps(props) {
		let sortedData = props.SideData.data.slice().sort((a, b) => a.order - b.order);
		this.oldData = props.SideData.data.slice();
		let data = sortedData.map((i) => ({ ...i }));
		this.oldcompleteState = sortedData.find((item) => item.completeState);

		let options = [];
		if (props.SideData.fieldName === "State") {
			options = [...data];
		}
		this.setState({
			data: data,
			completeState: sortedData.find((item) => item.completeState),
			olddata: data.slice(),
			options,
		});
		this.rowClick(sortedData[0]._id);
	}

	reorder(dataItem) {
		if (this.state.activeItem === dataItem) {
			return;
		}

		let reorderedData = this.state.data.slice();

		let prevIndex = reorderedData.findIndex((p) => p._id === this.state.activeItem._id);
		let nextIndex = reorderedData.findIndex((p) => p._id === dataItem._id);

		reorderedData.splice(prevIndex, 1);
		reorderedData.splice(nextIndex, 0, this.state.activeItem);

		this.setState({
			data: reorderedData,
			active: this.state.activeItem,
		});
	}

	updateOrder = (id, ordertoUpdate) => {
	};

	endDrag(dataItem) {
		let reorderedData = this.state.data.slice();
		let index = reorderedData.findIndex((x) => x._id === this.state.activeItem._id);

		let newOrder;

		if (reorderedData.length > 2) {
			if (index === reorderedData.length - 1) {
				newOrder = parseInt(reorderedData[index - 1]["order"]) + 10000000000;
				reorderedData[index]["order"] = newOrder.toString();
				this.updateOrder(reorderedData[index]._id, newOrder);
			} else if (index === 0) {
				newOrder = parseInt(reorderedData[1]["order"]);
				let prevElementOrder = parseInt(reorderedData[2]["order"]);
				let orderToSet = (prevElementOrder + newOrder) / 2;
				newOrder = newOrder.toString();
				reorderedData[index]["order"] = newOrder.toString();
				reorderedData[1]["order"] = orderToSet.toString();
				this.updateOrder(reorderedData[index]._id, newOrder);
				this.updateOrder(reorderedData[1]._id, orderToSet);
				////console.log(prevElementOrder, orderToSet, index);
			} else {
				let prevItemOrder = parseInt(reorderedData[index - 1]["order"]);
				let nextItemOrder = parseInt(reorderedData[index + 1]["order"]);
				newOrder = (prevItemOrder + nextItemOrder) / 2;
				reorderedData[index]["order"] = newOrder.toString();
				this.updateOrder(reorderedData[index]._id, newOrder);
			}
		} else {
			let firstOrder = reorderedData[0]["order"];
			let secondOrder = reorderedData[1]["order"];

			reorderedData[0]["order"] = secondOrder.toString();
			reorderedData[1]["order"] = firstOrder.toString();

			this.updateOrder(reorderedData[0]._id, secondOrder);
			this.updateOrder(reorderedData[1]._id, firstOrder);
		}

		for (let i = 0; i < reorderedData.length; i++) {
			reorderedData[i]._id = i + 1;
		}

		this.setState({
			data: reorderedData,
			selectedId: this.state.oldSelectedId,
		});
	}

	dragStart(dataItem) {
		var oldSelectedId = this.state.selectedId;
		this.setState({
			data: this.state.data,
			activeItem: dataItem,
			oldSelectedId: oldSelectedId,
			selectedId: dataItem._id,
		});
	}

	render() {
		return (
			<>
				{this.state.DeletePopup && (
					<RemoveDialog
						toggleDeleteDialog={this.toggleDeleteDialog}
						onDelete={!this.state.delete.key ? this.DeleteConfirmation : this.toggleDeleteDialog}
						Title="Delete field value"
						message={
							!this.state.delete.key ? `Are you sure you want to delete ${this.state.toDeleteItem.key} field value ?` : this.state.delete.message
						}
						hideCancelButton={!this.state.delete.key ? false : true}
						deleteButtonText={!this.state.delete.key ? "Delete" : "Ok"}
					/>
				)}
				<form tabIndex="0" onKeyDown={this.handleKeyboardSubmit} className="h-100">
					<div className="d-flex flex-column h-100">
						<div>
							<EditorActions
								header="Planning Fields"
								value={this.props.SideData.fieldName}
								disabled={true}
								ShowMoreButtons={false}
								hasErrors={!this.isSaveDisabled()}
								redoClicked={this.setDefault}
								customButtonText={this.props.userRole === "Member" ? "" : "Field value"}
								customButtonIcon="plus"
								customButtonClicked={this.addColumn}
								saveClicked={this.save}
								active={this.isSaveDisabled()}
							></EditorActions>
						</div>


						<Scrollable>
							<div className="p-1">
								<Grid
									data={this.state.data.map((item, index) => ({
										...item,
										selected: item._id === this.state.selectedId,
										indexId: index + 1,
										onChange: this.onChange,
										//onSave: this.save,
									}))}
									onRowClick={this.rowClick}
									// style={{ height: 'calc(100%)', width: '100%' }}
									resizable={false}
									reorderable={true}
									className="planning-grid"
								>
									<Column field="indexId" title="#" width={43} cell={DragCell} />
									<Column title="Field Values" cell={InputCell} />
									{this.props.userRole !== "Member" && (
										<Column
											width={40}
											cell={(props) =>
												props.dataItem.key === "Feedback" || this.state.data.length === 1 ? (
													<td></td>
												) : (
													<td>
														<i onClick={() => this.delete(props.dataItem)} className="fa fa-times"></i>
													</td>
												)
											}
										/>
									)}
								</Grid>
								{this.props.SideData.fieldName === "State" && (
									<>
										<div className="form-label">Complete state</div>
										<ComboBox
											allowCustom={false}
											textField="key"
											disabled={this.props.userRole === "Member"}
											onChange={this.handleCompleteState}
											value={this.state.completeState}
											data={this.state.options}
											name="Default Value"
											className="form-control-custom"
										/>
									</>
								)}
							</div>
						</Scrollable>
					</div>
				</form>
			</>
		);
	}

	addColumn = (e) => {
		e.preventDefault();
		let data = {
			_id: uuidv4(),
			isNew: true,
			key: ""
		};
		let dataitem = this.state.data;
		dataitem.push(data);
		this.setState({
			data: dataitem,
		});
	};

	toggleDeleteDialog = (e) => {
		this.setState({
			DeletePopup: false,
			delete: {
				key: false,
				message: "",
			},
		});
	};

	DeleteConfirmation = async (e) => {
		e.target.disabled = true;
		const id = this.state.toDeleteItem._id;
		const data = this.state.data.filter((x) => x._id !== id);
		let field = "";
		for (let Item of data) {
			field = field + Item.key + ", ";
		}
		let olddata = this.props.SideData;
		field = field.slice(0, -2);
		olddata.fieldValues = field;
		olddata.data = data;

		deleteNode(id);
		this.setState({
			DeletePopup: !this.state.DeletePopup,
			toDeleteItem: [],
			data: [...data],
			olddata: [...data],
		});
		this.props.onSidebarchange(olddata);
	};

	rowClick = (value) => {
		var id = "";
		if (value["dataItem"]) {
			id = value.dataItem._id;
		} else {
			id = value;
		}
		this.setState({ selectedId: id });
	};

	onChange = (dataItem) => {
		let data = this.state.data;
		let targetId = dataItem.target.getAttribute("data-id");
		let index = data.findIndex((item) => item._id === targetId);
		data[index].key = dataItem.target.value;
		data[index].error = dataItem.target.value === "";
		this.setState({ data: data, }, () => {
			this.isSaveDisabled();
		});
	};

	handleCompleteState = (e) => {
		this.setState({ completeState: e.target.value });
	};

	save = async (e) => {
		if (e) e.preventDefault();
		let field = "";
		let NewData = [];
		let oldData = this.state.data.filter((x) => !x.isNew);
		let newData = this.state.data.filter((x) => x.key !== "" && x.isNew);
		let SaveData = [...oldData, ...newData];
		let completeState = {};
		for (let data of SaveData) {
			if (this.props.SideData.fieldName === "State") {
				if (data._id === this.state.completeState._id || data.key === this.state.completeState.key) {
					data.completeState = true;
					completeState = { ...data };
				} else {
					data.completeState = false;
				}
			}
			if (data.isNew) {
				let order = 10000000000;
				if (SaveData.length > 0) {
					order = parseInt(SaveData[SaveData.length - 2].order) + 10000000000;
				}
				data.order = order.toString();
			}
			delete data.error;
			data.isNew = false;
			field = field + data.key + ", ";
			NewData.push(data);
		}
		await updatePlanningConfiguration(this.props.planningId, SaveData, this.props.SideData.databaseField);
		let data = this.props.SideData;
		field = field.slice(0, -2);
		data.fieldValues = field;
		data.data = NewData;
		let options = [];
		if (this.props.SideData.fieldName === "State") {
			options = [...NewData];
		}
		this.setState({
			data: NewData,
			olddata: NewData,
			options,
		});
		this.props.onSidebarchange(data);
	};

	delete = async (dataItem) => {
		const updatedData = this.state.data.filter((x) => x._id !== dataItem._id);
		this.setState({
			data: [...updatedData]
		});
	};

	setDefault = () => {
		let sortedData = this.props.SideData.data.slice().sort((a, b) => a.order - b.order);
		this.oldData = this.props.SideData.data.slice();
		let data = sortedData.map((i) => ({ ...i }));
		this.setState({
			data: data,
			completeState: sortedData.find((item) => item.completeState),
			olddata: data.slice(),
		});
	};

	isSaveDisabled = () => {
		if (this.state.data.length !== this.oldData.length) return false;
		for (let i = 0; i < this.state.data.length; i++) {
			if (this.oldData[i] && this.oldData[i].key !== this.state.data[i].key) {
				return false;
			}
		}
		if (this.props.SideData.fieldName === "State") {
			if (this.state.completeState._id !== this.oldcompleteState._id) {
				return false;
			}
		}
		return true;
	};
}

export default OrganisationPlanningSidebar;